import { DashboardMap } from "./type";

// inventory intial state
const initialDashboardDetails = {
  dashboardDetailsFlag1: null,
  dashboardDetailsFlag2: null,
  dashboardDetailsFlag3: null,
  dashboardDetailsFlag4: null,
  dashboardDetailsFlag5: null,
  dashboardDetailsFlag6: null,
  dashboardDetailsFlag7: null,
  dashboardDetailsFlag8: null,
  dashboardDetailsFlag9: null,
  error: null,
  isLoading: false,
  dash1Loader: true,
  dash2Loader: true,
  dash3Loader: true,
  dash4Loader: true,
  dash5Loader: true,
  dash6Loader: true,
  dash7Loader: true,
  dash8Loader: true,
  dash9Loader: true
};

export const reducer = (state = initialDashboardDetails, action) => {
  switch (action.type) {
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG1_REQUESTED: {
      const isLoading = true;
      return {
        ...state,
        isLoading: isLoading,
        error: null,
        dash1Loader: true
        // dash2Loader: true,
        // dash3Loader: true,
        // dash4Loader: true,
        // dash5Loader: true,
        // dash6Loader: true,
        // dash7Loader: true
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG1: {
      const dashboardDetailsFlag1 = action.payload.data;
      return {
        ...state,
        dashboardDetailsFlag1: dashboardDetailsFlag1,
        isLoading: false,
        dash1Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG1_FAILED: {
      const error = action.payload;
      return {
        ...state,
        error: error,
        isLoading: false,
        dash1Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG2: {
      const dashboardDetailsFlag2 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag2: dashboardDetailsFlag2,
        dash2Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG3: {
      const dashboardDetailsFlag3 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag3: dashboardDetailsFlag3,
        dash3Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG5: {
      const dashboardDetailsFlag5 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag5: dashboardDetailsFlag5,
        dash5Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG4: {
      const dashboardDetailsFlag4 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag4: dashboardDetailsFlag4,
        dash4Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG6: {
      const dashboardDetailsFlag6 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag6: dashboardDetailsFlag6,
        dash6Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG7: {
      const dashboardDetailsFlag7 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag7: dashboardDetailsFlag7,
        dash7Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG8: {
      const dashboardDetailsFlag8 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag8: dashboardDetailsFlag8,
        dash8Loader: false
      };
    }
    case DashboardMap.GET_DASHBOARD_DETAILS_FLAG9: {
      const dashboardDetailsFlag9 = action.payload;
      return {
        ...state,
        dashboardDetailsFlag9: dashboardDetailsFlag9,
        dash9Loader: false
      };
    }

    default:
      return state;
  }
};
